export default "__VITE_PUBLIC_ASSET__6447b5fb__"